import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

export default function VerificationBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification", { email: user.email });
      toast.success("Verification email sent! Check your inbox.");
    } catch {
      toast.error("Could not resend. Try again in a few minutes.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2.5 text-center" data-testid="verification-banner">
      <p className="text-sm text-amber-800 font-ui inline-flex items-center gap-2 flex-wrap justify-center">
        <Mail className="w-4 h-4 shrink-0" />
        Please check your email to verify your account.
        <button onClick={resend} disabled={sending}
          className="text-coral font-medium hover:underline disabled:opacity-50"
          data-testid="resend-verification-btn">
          {sending ? "Sending..." : "Resend verification email"}
        </button>
      </p>
    </div>
  );
}
